import {API} from '../../Services';
import {mobileModel, mobileVendor, osName, osVersion} from "react-device-detect";

async function InstallData(){
    let token =  localStorage.getItem('token');
    return API.get(`/users/clients?type=web&is_pwa_installed=true`,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function SetInstallData(){
    let obj ={
        "type":"web",
        "device":osName,
        "brand":mobileVendor,
        "model":mobileModel,
        "os_version":osVersion,
        "is_pwa_installed":true
    }
    // console.log("OBJ : ",obj);
    let token =  localStorage.getItem('token');
    return API.post(`/users/clients?type=web?`,obj,{ headers: { 'Authorization':  `Bearer ${token}`} });
}


async function NavDataApi(){
    let token =  localStorage.getItem('token');
    let mallId =  localStorage.getItem('mallId');
    return API.get(`/malls/${mallId}/navbar-public`);
}



export {InstallData,SetInstallData,NavDataApi};
